import React from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from '../Header';
import { usePageTitle } from 'src/hooks/usePageTitle';

export function ManageBookingLayout({ children }: React.PropsWithChildren) {
    usePageTitle();
    return (
        <div className="flex min-h-dvh flex-col bg-gray-50">
            <Header hideCloseButton={true} />
            <main className="mx-auto my-20 flex w-full max-w-2xl flex-1 flex-col overflow-hidden p-5">
                <Outlet />
                {children}
            </main>
        </div>
    );
}
